import { Node } from 'tiptap'

export default class Noembed extends Node {

  commands(_ref) {
    let type = _ref.type;
    return function (attrs) {
      return function (state, dispatch) {
        let selection = state.selection;
        let position = selection.$cursor ? selection.$cursor.pos : selection.$to.pos;
        let node = type.create(attrs);
        let transaction = state.tr.insert(position, node);
        dispatch(transaction);
      };
    };
  }

  get name() {
    return 'noembed'
  }

  get schema() {
    return {
      attrs: {
        html: {
          default: null,
        },
      },
      group: 'block',
      selectable: false,
      parseDOM: [{
        tag: 'div[class="noembed-iframe"]',
        getAttrs: dom => ({
          html: dom.innerHTML,
        }),
      }],
      toDOM: node => {
        let el = document.createElement('div');
        el.classList.add('noembed-iframe')
        el.innerHTML = node.attrs.html
        return el
      },
    }
  }

  get view() {
    return {
      props: ['node', 'updateAttrs', 'view'],
      computed: {
        html: {
          get() {
            return this.node.attrs.html
          },
          set(html) {
            this.updateAttrs({
              html,
            })
          },
        },
      },
      render(h) {
        return h(
          'div', {
            staticClass: 'noembed-iframe',
            domProps: {
              innerHTML: this.html
            }
          }
        )
      }
    }
  }
}
